"use client";
import CustomCarousel from "@/components/CustomCarousel/CustomCarousel.js";
import Link from "next/link";
import BlogCard from "./BlogCard/BlogCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs, selectAllBlogs } from "@/slice/blogsSlice";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import "./homePageCarousel.css";
import "./blogsCarousel.scss";

export default function BlogsCarousel({
  itemsPerPage,
  blogsData,
  isHomePage = false,
}) {
  const dispatch = useDispatch();
  const Data = useSelector(selectAllBlogs);
  const blog = blogsData || Data;
  const intl = useIntl();

  const lang = useSelector((state) => state.locale.locale);
  useEffect(() => {
    !blogsData && dispatch(fetchBlogs(lang));
  }, [lang]);

  return (
    <div
      className={`px-4 sm:px-6 md:px-8 py-8 ${isHomePage ? "bg-white" : "bg-gray-50"}`}
    >
      <div className="max-w-7xl mx-auto">
        <p className="font-roboto-slab text-[30px] sm:text-3xl font-medium text-center mb-6">
          <span className="text-gray-500 font-light">
            {intl.formatMessage({ id: "fresh", defaultMessage: "Fresh" })}{" "}
          </span>
          <span style={{ color: "#00428a" }}>
            {intl.formatMessage({ id: "blogs", defaultMessage: "Blogs" })}
          </span>
        </p>

        <div className={isHomePage ? "relative" : ""}>
          <CustomCarousel
            itemsPerPage={itemsPerPage}
            previousButtonClassName="xl:-left-[46px] lg:-left-[24px] -left-[2px] translate-x-1/2"
            nextButtonClassName="xl:-right-[6px] lg:-right-[24px] -right-[2px] translate-x-1/2"
          >
            {blog?.data?.length > 0 &&
              [...blog.data]
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .map((blog, i) => (
                  <BlogCard key={i} blog={blog} isHomePage={isHomePage} />
                ))}
          </CustomCarousel>
        </div>

        <div className="mt-6 text-center">
          <Link href="/blogs" className="viewMoreBtn">
            {intl.formatMessage({ id: "viewAllBlogs" })}
          </Link>
        </div>
      </div>
    </div>
  );
}
